import React from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import {makeStyles, Typography} from "@material-ui/core";
import UploadFile from "components/UploadFile";
import Box from "@material-ui/core/Box";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import BoldTypography from "components/BoldTypography";
import getObjectValue from "libs/getObjectValue";
import VS from "constants/ValidationShema";


export const createConfirmObject = (message, confirmFn, cancelFn) => {
    return {
        message,
        confirm: confirmFn,
        cancel: cancelFn
    }
}

const useStyle = makeStyles(theme => ({
        message: {
            whiteSpace: 'pre-line',
            margin: `${theme.spacing(2)}px 0`
        },
        actionWrap: {
            display: 'block',
            width: '100%',
            textAlign: 'center',
            borderTop: '2px solid',
            marginTop: theme.spacing(3),
            paddingTop: theme.spacing(1)
        }
    }
));

function PublishMessageConfirmationPopup(
    {
        publishMessageInfo
    }) {


    const classes = useStyle();


    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), () => {
            publishMessageInfo.cancel();
        }, 'outlined', false));
        buttons.push(createButton(Tr('publish'), () => {
            publishMessageInfo.confirm();
        }, undefined, false));
        return buttons;
    }

    const getDialogActions = () => (<div className={classes.actionWrap}>
        <BoldTypography>{Tr('publish_message_popup_text1')}</BoldTypography>
        <BoldTypography>{Tr('publish_message_popup_text2')}</BoldTypography>
        <MultiButton buttons={getButtons()} />
    </div>)


    return (
        <Dialog
            title={Tr("publish_message_popup_header")}
            open={true}
            maxWidth='md'
            dialogActions={getDialogActions()}
        >
            <Form
                initialValues={{
                    _editable: false,
                    contents: publishMessageInfo.message.contents,
                    attachments: publishMessageInfo.message.attachments
                }}
                validationSchema={VS.any()}
                onSubmit={() => {
                }}
                id='0'
            >
                {(formikProps) => (
                    <GridBlock column>

                        <BoldTypography>{Tr('contents')}</BoldTypography>
                        <Typography className={classes.message}>{getObjectValue('contents', formikProps.values, '')}</Typography>

                        {!!formikProps.values?.attachments.length && <Box component="div" className={classes.uploadFile}>
                            <UploadFile
                                id='attachments'
                                formikProps={formikProps}
                                label={Tr("attachment")}
                                disabled
                            />
                        </Box>}

                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default PublishMessageConfirmationPopup;